<template>
  <div style=" background: #f0f4f8;">

    <div class="containertable" style="display: flex">
      <v-progress-linear v-if="loadingActive" color="#2A5377" style="width: 100%; margin-left: 50px; margin-right: 50px;"
          indeterminate>
      </v-progress-linear>      
      <md-card v-else style="margin: 20px; display: flex; flex-direction: column;">
        <DataTableBoletos :boletos="boletos" :loadingActive="loadingActive" :noDataText="noDataText" tituloTabela="Boletos"></DataTableBoletos>
      </md-card>
    </div>
  </div>
</template>
<script>

import * as BoletosService from "../../providers/boletos.service";
import DataTableBoletos from "./DataTableBoletos";

export default {
  props: ["mesano", "boletos", "exibirSomenteAbertos"],
  data() {
      return {
        loadingActive: true,
        boletos: [],
        noDataText: "Aguarde...",
        headers: [
          {
            text: "Produto",
            value: "bug_id"
          },
          {
            text: "Produto",
            value: "component"
          },
          {
            text: "Versão",
            value: "short_desc"
          },
          {
            text: "Versão Interna",
            value: "priority"
          }
        ]
      }
  },
  components:{
    DataTableBoletos
  },
  watch: {
    exibirSomenteAbertos() {
        var self = this;

        BoletosService.getBoletos(self.mesano.MES, self.mesano.ANO, (self.exibirSomenteAbertos == true ? "BOLSITUACAO = 'A'" : ""))
        .then(r => {
            self.boletos = r;
            self.loadingActive = false;
            self.noDataText = 'Nada foi encontrado.';
        });
    }
  },
  created() {
    var self = this;

    BoletosService.getBoletos(self.mesano.MES, self.mesano.ANO, (self.exibirSomenteAbertos == true ? "BOLSITUACAO = 'A'" : ""))
      .then(r => {
        self.boletos = r;
        self.loadingActive = false;
        self.noDataText = 'Nada foi encontrado.';
      });
  },
  methods: {
    downloadWFile(item) {
      var self = this;
      self.forceFileDownload(item);
    },
    forceFileDownload(item) {
      this.msg = "Seu download começou..";
      var win = window.open(item, "_blank");
    },    
  }  
};
</script>
<style scoped>
.controlstop {
  display: flex;
  justify-content: flex-end;
}
.v-datatable__actions__range-controls {
  color: #000;
}
.subtitle-2 {
  min-height: 30px;
}
.overlayy {
  z-index: 10;
  background: rgba(0, 0, 0, 0.39);
  position: absolute;
  width: 100%;
  height: 99%;
  top: 0;
  border-radius: 5px;
  left: 0;
}
li {
  min-height: 58px;
}

span,
div,
table,
td,
tr,
th {
  transition: all 0.3s ease !important;
}

.md-theme-default a:hover {
  color: #00aaff !important;
  text-decoration: underline !important;
}

table.v-table tbody td, table.v-table tbody th{
  height: 33px;
}

.rs-data-title{
  display: flex;
  justify-content: center;
}

</style>